<router-outlet></router-outlet>

<ng-template #subsubmenuContent>
    <div class="subSideMenu">
        @let active = store.activeIndex$ | async;
        @if (active) {
            <ul class="list-none px-3">
                <ng-container
                    *ngTemplateOutlet="itemGroup; context: { itemGroup: itemsFirstGroup, active: active }"></ng-container>
                <li class="subSideMenu-header">
                    <div>{{ 'service.settings.sidebar.folder' | translate }}</div>
                </li>
                <ng-container
                    *ngTemplateOutlet="itemGroup; context: { itemGroup: itemsSecondGroup, active: active }"></ng-container>
                <li class="subSideMenu-header">
                    <div>{{ 'service.settings.sidebar.other' | translate }}</div>
                </li>
                <ng-container
                    *ngTemplateOutlet="itemGroup; context: { itemGroup: itemsThirdGroup, active: active }"></ng-container>
            </ul>
        }

    </div>
</ng-template>

<ng-template #itemGroup let-itemGroup="itemGroup" let-active="active">
    @for (item of itemGroup; track $index) {
        <li class="subSideMenu-item">
            <div
                pRipple
                [ngClass]="['subSideMenu-link', item === active ? 'subSideMenu-link_active' : '']"
                (click)="itemOnClick(item)"
            >
                {{ 'service.settings.sidebar.' + item | translate }}
            </div>
        </li>
    }
</ng-template>
